import { api } from '../servicingApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getServicingV1AccountsLenderAccountIdentifierBankAccounts: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_accounts`,
            }),
        }),
        postServicingV1AccountsLenderAccountIdentifierBankAccounts: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_accounts`,
                method: 'POST',
                body: queryArg.postServicingV1AccountsLenderAccountIdentifierBankAccounts,
            }),
        }),
        postServicingV1AccountsLenderAccountIdentifierBankAccountsManual: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_accounts/manual`,
                method: 'POST',
                body: queryArg.postServicingV1AccountsLenderAccountIdentifierBankAccountsManual,
            }),
        }),
        postServicingV1AccountsLenderAccountIdentifierBankVerification: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_verification`,
                method: 'POST',
            }),
        }),
        getServicingV1AccountsLenderAccountIdentifierBankVerification: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_verification`,
            }),
        }),
        putServicingV1AccountsLenderAccountIdentifierBankVerificationExchangePublicToken: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/accounts/${queryArg.lenderAccountIdentifier}/bank_verification/exchange_public_token`,
                method: 'PUT',
                body: queryArg.putServicingV1AccountsLenderAccountIdentifierBankVerificationExchangePublicToken,
            }),
        }),
        getServicingV1Instruments: build.query({
            query: () => ({ url: `/servicing/v1/instruments` }),
        }),
        getServicingV1InstrumentsTokenToken: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/token/${queryArg.token}`,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdAlerts: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/alerts`,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdBalance: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/balance`,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdBillingSummaryDetails: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/billing_summary_details`,
            }),
        }),
        patchServicingV1InstrumentsInstrumentIdScheduledPaymentsIdCancel: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/scheduled_payments/${queryArg.id}/cancel`,
                method: 'PATCH',
            }),
        }),
        getServicingV1InstrumentsInstrumentId: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}`,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdActivity: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/activity`,
                params: {
                    page: queryArg.page,
                    per_page: queryArg.perPage,
                    max_date: queryArg.maxDate,
                    min_date: queryArg.minDate,
                    type: queryArg['type'],
                },
            }),
        }),
        postServicingV1InstrumentsInstrumentIdPayments: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/payments`,
                method: 'POST',
                body: queryArg.postServicingV1InstrumentsInstrumentIdPayments,
            }),
        }),
        putServicingV1InstrumentsInstrumentIdAgreementSign: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/agreement/sign`,
                method: 'PUT',
                body: queryArg.putServicingV1InstrumentsInstrumentIdAgreementSign,
            }),
        }),
        putServicingV1InstrumentsInstrumentIdAutopaySettings: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/autopay_settings`,
                method: 'PUT',
                body: queryArg.putServicingV1InstrumentsInstrumentIdAutopaySettings,
            }),
        }),
        postServicingV1InstrumentsInstrumentIdChangeAutopay: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/change_autopay`,
                method: 'POST',
                body: queryArg.postServicingV1InstrumentsInstrumentIdChangeAutopay,
            }),
        }),
        postServicingV1InstrumentsInstrumentIdBankVerification: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/bank_verification`,
                method: 'POST',
            }),
        }),
        getServicingV1InstrumentsInstrumentIdBankVerification: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/bank_verification`,
            }),
        }),
        putServicingV1InstrumentsInstrumentIdBankVerificationExchangePublicToken: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/bank_verification/exchange_public_token`,
                method: 'PUT',
                body: queryArg.putServicingV1InstrumentsInstrumentIdBankVerificationExchangePublicToken,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdFinalize: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/finalize`,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdAgreementsTermsTemplateName: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/agreements/terms/${queryArg.templateName}`,
            }),
        }),
        postServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorization: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/agreements/terms/ach_authorization`,
                method: 'POST',
                body: queryArg.postServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorization,
            }),
        }),
        getServicingV1InstrumentsInstrumentIdDocuments: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/instruments/${queryArg.instrumentId}/documents`,
                params: {
                    status: queryArg.status,
                },
            }),
        }),
        postServicingV1BankTransfersWebhooks: build.mutation({
            query: (queryArg) => ({
                url: `/servicing/v1/bank_transfers/webhooks`,
                method: 'POST',
                body: queryArg.postServicingV1BankTransfersWebhooks,
            }),
        }),
        getServicingV1BankNameLookup: build.query({
            query: (queryArg) => ({
                url: `/servicing/v1/bank_name_lookup`,
                params: {
                    routing_number: queryArg.routingNumber,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as servicingApi };
export const { useGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery, useLazyGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery, usePostServicingV1AccountsLenderAccountIdentifierBankAccountsMutation, usePostServicingV1AccountsLenderAccountIdentifierBankAccountsManualMutation, usePostServicingV1AccountsLenderAccountIdentifierBankVerificationMutation, useGetServicingV1AccountsLenderAccountIdentifierBankVerificationQuery, useLazyGetServicingV1AccountsLenderAccountIdentifierBankVerificationQuery, usePutServicingV1AccountsLenderAccountIdentifierBankVerificationExchangePublicTokenMutation, useGetServicingV1InstrumentsQuery, useLazyGetServicingV1InstrumentsQuery, useGetServicingV1InstrumentsTokenTokenQuery, useLazyGetServicingV1InstrumentsTokenTokenQuery, useGetServicingV1InstrumentsInstrumentIdAlertsQuery, useLazyGetServicingV1InstrumentsInstrumentIdAlertsQuery, useGetServicingV1InstrumentsInstrumentIdBalanceQuery, useLazyGetServicingV1InstrumentsInstrumentIdBalanceQuery, useGetServicingV1InstrumentsInstrumentIdBillingSummaryDetailsQuery, useLazyGetServicingV1InstrumentsInstrumentIdBillingSummaryDetailsQuery, usePatchServicingV1InstrumentsInstrumentIdScheduledPaymentsIdCancelMutation, useGetServicingV1InstrumentsInstrumentIdQuery, useLazyGetServicingV1InstrumentsInstrumentIdQuery, useGetServicingV1InstrumentsInstrumentIdActivityQuery, useLazyGetServicingV1InstrumentsInstrumentIdActivityQuery, usePostServicingV1InstrumentsInstrumentIdPaymentsMutation, usePutServicingV1InstrumentsInstrumentIdAgreementSignMutation, usePutServicingV1InstrumentsInstrumentIdAutopaySettingsMutation, usePostServicingV1InstrumentsInstrumentIdChangeAutopayMutation, usePostServicingV1InstrumentsInstrumentIdBankVerificationMutation, useGetServicingV1InstrumentsInstrumentIdBankVerificationQuery, useLazyGetServicingV1InstrumentsInstrumentIdBankVerificationQuery, usePutServicingV1InstrumentsInstrumentIdBankVerificationExchangePublicTokenMutation, useGetServicingV1InstrumentsInstrumentIdFinalizeQuery, useLazyGetServicingV1InstrumentsInstrumentIdFinalizeQuery, useGetServicingV1InstrumentsInstrumentIdAgreementsTermsTemplateNameQuery, useLazyGetServicingV1InstrumentsInstrumentIdAgreementsTermsTemplateNameQuery, usePostServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorizationMutation, useGetServicingV1InstrumentsInstrumentIdDocumentsQuery, useLazyGetServicingV1InstrumentsInstrumentIdDocumentsQuery, usePostServicingV1BankTransfersWebhooksMutation, useGetServicingV1BankNameLookupQuery, useLazyGetServicingV1BankNameLookupQuery, } = injectedRtkApi;
